(function () {
  function init(root) {
    var track = root.querySelector('[data-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 6000;

    function go(i, smooth) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }
    function mark(i) {
      index = i;
      dots.forEach(function (d, n) { n === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) mark(slides.indexOf(e.target)); });
    }, { root: track, threshold: [0.6] });
    slides.forEach(function (s) { io.observe(s); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n, true); restart(); }); });

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduce || root.getAttribute('data-autoplay') !== 'true' || document.documentElement.classList.contains('shopify-design-mode')) return;
      stop(); timer = setInterval(function () { go(index + 1, true); }, delay);
    }
    function restart() { stop(); start(); }
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, stop, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, start); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(index + 1, true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(index - 1, true); e.preventDefault(); }
    });
    start();
  }
  document.querySelectorAll('[data-obil-banners]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector && e.target.querySelector('[data-obil-banners]');
    if (r) init(r);
  });
})();
